import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Userimg from '../Images/icons8-user-50.png';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import { fetchDataDB, retrieveData } from '../apis/dataService';
import { Categories } from '../Data/Categories';
import Cards from '../MyComponents/Cards';
import { addKeyValuePair } from '../utils/generalfunctions';
import LoginBoom from "../MyComponents/LoginBoom";
import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';

const SearchPage = () => {
    const location = useLocation();
    const [results, setResults] = useState(location.state?.results || []);
    const [category, setCategory] = useState(location.state?.name || '');

    const [value, setValue] = useState(100);
    const barRef = useRef(null);
    const circleRef = useRef(null);

    useEffect(() => {
        if (location.state?.results) {
            setResults(location.state.results);
        }
    }, [location.state?.results]);
    
    useEffect(() => {
        const handleMouseMove = (e) => {
            if (circleRef.current && circleRef.current.dragging) {
                const barRect = barRef.current.getBoundingClientRect();
                let newValue = ((e.clientX - barRect.left) / barRect.width) * 100;
                newValue = Math.max(0, Math.min(100, newValue)); // Ensure the value is between 0 and 100
                setValue(newValue);
            }
        };

        const handleMouseUp = () => {
            if (circleRef.current) {
                circleRef.current.dragging = false;
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (category) {
                try {
                    const fetchedCards = await findProductsByCategory(category);
                    setResults(fetchedCards);
                } catch (error) {
                    console.error('Error in fetchData:', error);
                }
            }
        };

        fetchData();
    }, [category]);

    const findProductsByCategory = async (searchCategory) => {
        try {
            const response = await axios.get(`${BackendURL}/search-category/${searchCategory}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        if (circleRef.current) {
            circleRef.current.dragging = true;
        }
    };

    const updateProducts = (category) => {
        setCategory(category);
    };

    const [menuVisible, setMenuVisible] = useState(false);
    const ToggleSearchMenu = () => {
        setMenuVisible(!menuVisible);
    };

    return (
        <div className='SearchPage-body'>
            <div className={`SideSearchOptions ${menuVisible ? 'open' : ''}`} id='Categories-search-menu'>
                <div className="SideSearch-categories">
                    <h2>Categories</h2>
                    <div className="sidesearch-category" onClick={() => updateProducts("AllProducts")}>
                        All Products
                    </div>
                    {Categories.map((item, index) => (
                        <div className="sidesearch-category" key={index} onClick={() => updateProducts(item)}>
                            {item}
                        </div>
                    ))}
                </div>
                <div className='MaxPrice-parent'>
                    <h2 className='MaxPrice'>
                        Maximum Price: {Math.round(value * 100)} -/Rs
                    </h2>
                    <div className='CircleSliderBar'
                        ref={barRef}
                        style={{
                            background: `linear-gradient(to right, #2ca52c ${value}%, #ccc ${value}%)`,
                        }}
                    >
                        <div className='CircleSliderBar-circle'
                            ref={circleRef}
                            onMouseDown={handleMouseDown}
                            style={{
                                left: `${value}%`,
                            }}
                        />
                    </div>
                </div>
            </div>
            <div onClick={ToggleSearchMenu} className={`search-toggle-menu-btn  ${menuVisible ? 'open' : ''}`}>
                <i className={`fas fa-chevron-${menuVisible ? 'left' : 'right'}`}>
                </i>
            </div>
            <div className="search-results">
                <h2 className='search-result-h2'>Search Results:</h2>
                <div className="search-result">
                    {results.map((result, index) => (
                        <Cards
                            name={result.ItemName}
                            key={index}
                            index={`Search-Cardno.${index}`}
                            category={result.ItemCategory}
                            imgname={result.ItemName}
                            price={result.SalePrice}
                            description={result.description}
                        />
                    ))}
                </div>
            </div>
            <LoginBoom />
        </div>
    );
};

export default SearchPage;
